import { displayError } from './api-client';

export type ApiErrorData = {
  status?: number;
  message?: string;
  endpoint?: string;
  payload?: any; // raw error response data (if available)
  raw?: any; // original thrown error
};

export type NormalizedApiError = {
  status?: number;
  message: string;
  category: 'auth' | 'client' | 'server' | 'network' | 'unknown';
  endpoint?: string;
};

export interface HandleApiErrorOptions {
  hideToast?: boolean;
  endpoint?: string;
}

// Map status codes to a category and retry hint
// const categorizeStatus = (status?: number): Pick<NormalizedApiError, 'category'> => {
//   switch (status) {
//     case 400:
//     case 404:
//     case 412:
//       return { category: 'client' };
//     case 401:
//     case 403:
//       return { category: 'auth' };
//     case 500:
//       return { category: 'server' };
//     case 503:
//     case 504:
//       return { category: 'server' };
//     // network or undefined status (e.g., CORS / offline / SDK didn't expose)
//     case 0:
//     case undefined:
//       return { category: 'network' };
//     default:
//       return { category: 'unknown' };
//   }
// };

// const DEFAULT_MESSAGES: Record<string, string> = {
//   auth: 'Authentication error',
//   client: 'Request error',
//   server: 'Server error',
//   network: 'Network error',
//   unknown: 'Unexpected error',
// };

export class ApiError extends Error implements NormalizedApiError {
  status?: number;
  category: 'auth' | 'client' | 'server' | 'network' | 'unknown';
  original?: ApiErrorData;
  constructor(normalized: NormalizedApiError) {
    super(normalized.message);
    this.status = normalized.status;
    this.category = normalized.category;
  }
}

// function deriveMessage(error: ApiErrorData, category: NormalizedApiError['category']): string {
//   if (error.message && typeof error.message === 'string') return error.message;
//   return DEFAULT_MESSAGES[category];
// }

export function handleApiError(error: any, options: HandleApiErrorOptions = {}, customConfig: any) {
  // const { hideToast, endpoint } = options;

  // const { category } = categorizeStatus(error.status);

  // const msg = deriveMessage(error, category);

  // const normalized: NormalizedApiError = {
  //   status: error.status,
  //   message: msg,
  //   category,
  //   endpoint,
  // };
  // logger.error('Normalized API error', normalized);
  // if (!hideToast) {
  //   try {
  //     toast.error(msg);
  //   } catch (e) {
  //     /* toast not available */
  //   }
  // }
  // return normalized;

  if (error.status === 403) {
    displayError(
      error.message || error?.errorData?.message || 'Forbidden',
      customConfig?.shouldHide,
    );
    return Promise.reject(error.message || error?.error?.message || 'Forbidden');
  } else if (error.status === 412) {
    displayError(
      error.message || error?.error?.message || 'Invalid grand',
      customConfig?.shouldHide,
    );
    return Promise.reject(
      error?.errorData || error.message || error?.errorData?.message || 'Invalid grand',
    );
  } else if (error.status === 400 || error.status === 404) {
    let message = error?.errorData || error.message;
    if (error.errorData?.errorDetails) {
      message = error.errorData.errorDetails.map((e: any) => `${e.message || e.error}`).join(', ');
    }
    displayError(message?.message || message || 'Forbidden', customConfig?.shouldHide);
    return Promise.reject(message);
  } else if (error.status === 500 || error.status === 504 || error.status === 503) {
    let message = error.errorData || error.message;
    if (error.errorData?.errorDetails) {
      message = error.errorData.errorDetails.map((e: any) => `${e.message || e.error}`).join(', ');
    }
    displayError(message || 'Forbidden', customConfig?.shouldHide);
    return Promise.reject(message);
  }

  // const normalized = handleApiError({
  //   status: response.status,
  //   message: response.statusText,
  //   endpoint,
  // });
  // return Promise.reject(normalized.message);
  displayError(error.statusText || 'Something went wrong', customConfig?.shouldHide);
  return Promise.reject(error.statusText);
}
